import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from '@/components/Button';
import routes from '@/routes';
import { AUTH_MODAL_TYPES, openAuthModal } from '@/store/profile';

function AuthButtons() {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const loggedIn = useSelector(state => state.profile.loggedIn);

	if (loggedIn) {
		return (
			<Button
				Component={Link}
				to={routes.myDocuments}
				variant="outlineWhite"
			>
				{t('common.goToMyAccount')}
			</Button>
		);
	}

	return (
		<>
			<Button
				variant="outlineWhite"
				onClick={() => {
					dispatch(openAuthModal({ type: AUTH_MODAL_TYPES.LOGIN }));
				}}
			>
				{t('common.login')}
			</Button>
			<Button
				variant="secondary"
				onClick={() => {
					dispatch(openAuthModal({ type: AUTH_MODAL_TYPES.SIGN_UP }));
				}}
			>
				{t('common.signUp')}
			</Button>
		</>
	);
}

export default AuthButtons;
